import { read, utils, type WorkBook } from "xlsx"

export async function readXlsxFile(file: string) {
  let workbook: WorkBook
  if (import.meta.server) {
    const fs = await import("fs/promises")
    const buffer = await fs.readFile(`./public` + file)
    workbook = read(buffer, { type: "buffer" });
  }
  if (import.meta.client) {
    const binary = await $fetch(file, { responseType: "arrayBuffer" })
    workbook = read(binary, { type: "binary" });
  }

  const sheet = workbook!.Sheets["Sheet1"]
  const records = utils.sheet_to_json<Record<string, unknown>>(sheet)

  return records
}